export default class satistics {
    device_connected;
    device_active;
    device_storehouse;
    user_number;
    user_owner;
    user_subscribed;
    financial_total;
    financial_device;
    financial_subscribe;
    new_order;
    progress_order;
    delivered_order;
    panel_massage_inventory;
    panel_port_inventory;
    panel_settling_inventory;

    constructor(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o) {
        this.device_connected = a;
        this.device_active = b;
        this.device_storehouse = c;
        this.user_number = d;
        this.user_owner = e;
        this.user_subscribed = f;
        this.financial_total = g;
        this.financial_device = h;
        this.financial_subscribe = i;
        this.new_order = j;
        this.progress_order = k;
        this.delivered_order= l;
        this.panel_massage_inventory= m;
        this.panel_port_inventory= n;
        this.panel_settling_inventory= o;
    }
}